import BlockIcon from '@mui/icons-material/Block';
import { Button, useTheme } from '@mui/material';
import React, { useCallback } from 'react';

import { controlBaseSx, CONTROL_FONT_SIZE } from './filterBarStyles';

export interface FilterBarClearButtonProps {
  onClear: () => void;
}

export const FilterBarClearButton: React.FC<FilterBarClearButtonProps> = ({ onClear }) => {
  const theme = useTheme();

  // FilterBar's outer Box listens for Enter to trigger Search. Without this,
  // keyboard-Enter on the Clear button would bubble up and fire a search with
  // the still-pre-clear filter state before the click handler resets it.
  const handleKeyDown = useCallback((e: React.KeyboardEvent<HTMLButtonElement>) => {
    if (e.key === 'Enter') e.stopPropagation();
  }, []);

  return (
    <Button
      size="small"
      startIcon={<BlockIcon sx={{ fontSize: 14 }} />}
      onClick={onClear}
      onKeyDown={handleKeyDown}
      aria-label="Clear all filters"
      sx={{
        ...controlBaseSx(theme),
        textTransform: 'none',
        fontSize: CONTROL_FONT_SIZE,
        fontWeight: 500,
        // Resting slate, red only on hover/focus. Clear is always on screen and
        // clears nothing destructive, so a permanent red button spent attention
        // the strip needed for the filters themselves.
        '& .MuiButton-startIcon': { mr: 0.5 },
        '&:hover, &:focus-visible': {
          color: theme.palette.error.main,
          borderColor: theme.palette.error.main,
          bgcolor: 'transparent',
        },
      }}
    >
      Clear
    </Button>
  );
};
